import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ConfigProvider } from "@/lib/config";
import { SubscriptionProvider } from "@/lib/subscription";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PricingPage from "@/pages/PricingPage";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import { TermsPage, PrivacyPage } from "@/pages/LegalPages";
import AppLayout from "@/components/AppLayout";
import DashboardPage from "@/pages/DashboardPage";
import OpportunitiesListPage from "@/pages/OpportunitiesListPage";
import OpportunityDetailPage from "@/pages/OpportunityDetailPage";
import MapsPage from "@/pages/MapsPage";
import AISearchPage from "@/pages/AISearchPage";
import CRMPage from "@/pages/CRMPage";
import SavedSearchesPage from "@/pages/SavedSearchesPage";
import ReportsPage from "@/pages/ReportsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import SettingsPage from "@/pages/SettingsPage";
import AdminPage from "@/pages/AdminPage";
import AdminPromoCodesPage from "@/pages/AdminPromoCodesPage";
import AdminRevenuePage from "@/pages/AdminRevenuePage";
import AttomLookupPage from "@/pages/AttomLookupPage";
import ReferralsPage from "@/pages/ReferralsPage";
import WholesalePage from "@/pages/WholesalePage";
import PublicDealPage from "@/pages/PublicDealPage";
import DataSourcesPage from "@/pages/DataSourcesPage";
import AuditLogsPage from "@/pages/AuditLogsPage";
import BrokerListingsPage from "@/pages/BrokerListingsPage";
import MarketplacePage from "@/pages/MarketplacePage";
import InvestmentInsightsPage from "@/pages/InvestmentInsightsPage";
import { Toaster } from "@/components/ui/sonner";

import L from "leaflet";
import "leaflet/dist/leaflet.css";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfigProvider>
          <SubscriptionProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/deal/:code" element={<PublicDealPage />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="ai-search" element={<AISearchPage />} />
              <Route path="attom-lookup" element={<AttomLookupPage />} />
              <Route path="wholesale" element={<WholesalePage />} />
              <Route path="referrals" element={<ReferralsPage />} />
              <Route path="investments" element={<InvestmentInsightsPage />} />
              <Route path="maps" element={<MapsPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="opportunities/detail/:id" element={<OpportunityDetailPage />} />
              <Route path="opportunities/:category" element={<OpportunitiesListPage />} />
              <Route path="crm" element={<CRMPage />} />
              <Route path="saved-searches" element={<SavedSearchesPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="marketplace" element={<MarketplacePage />} />
              <Route path="broker" element={<BrokerListingsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="admin/revenue" element={<AdminRevenuePage />} />
              <Route path="admin/promo-codes" element={<AdminPromoCodesPage />} />
              <Route path="admin/data-sources" element={<DataSourcesPage />} />
              <Route path="admin/audit-logs" element={<AuditLogsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
          </SubscriptionProvider>
        </ConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
